import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotas: RouteConfig[] = [
	{
		path: 'dna-do-produto',
		name: 'DNA do Produto',
		components: {
			default: () =>
				import('@/views/application/produtos/TelaDeDnaDoProduto.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'dna-do-produto' as TipoDeRecurso,
		},
	},
]

export default rotas